import { defineComponent as _defineComponent } from 'vue'
import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';
import ProviderIconSquare from '@/features/ui/components/ProviderIconSquare.vue';

import { usePlotRecommenderStore } from './usePlotRecommenderStore';
import { useConstantStore } from '@/stores/pinia/useConstantStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'PlotRecommenderProviderFilter',
  setup(__props) {

const constantStore = useConstantStore();
const prStore = usePlotRecommenderStore();

const providers = constantStore.providers();

function toggle(shortName: string) {
	if (prStore.filters.packages.includes(shortName)) {
		prStore.filters.packages = prStore.filters.packages.filter(s => s !== shortName);
	} else {
		prStore.filters.packages.push(shortName);
	}
}

return { __sfc: true,constantStore, prStore, providers, toggle, HiddenHorizontalScrollbar, ProviderIconSquare }
}

})